import React, {useContext} from 'react';
import styles from '../../styles/components/TestimonialsSlider.module.scss';
import classnames from 'classnames';
import {stripHash} from '../../utils/anchors';
import {MobileContext} from '../../context/mobileContext';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import TestimonialItem from '../testimonial-item/testimonial-item';

const ITEMS_PER_SLIDE_DESKTOP = 2;

function Slide({startIdx, itemsPerSlide, items}) {
    const lastIdx = Math.min(startIdx + itemsPerSlide, items.length);
    const slideItems = [];

    for (let idx = startIdx; idx < lastIdx; idx++) {
        slideItems.push(
            <TestimonialItem key={`TestimonialItem${idx}`} data={items[idx]}/>
        );
    }

    return <div className={styles.slide}>{slideItems}</div>;
}

export default function TestimonialsSlider({data}) {
    const isMobile = useContext(MobileContext);

    const items = data.children || [];
    const itemsPerSlide = isMobile ? 1 : ITEMS_PER_SLIDE_DESKTOP;

    const slides = [];
    for (let idx = 0; idx < items.length; idx += itemsPerSlide) {
        slides.push(
            <Slide key={`Slide${idx}`} startIdx={idx} itemsPerSlide={itemsPerSlide} items={items}/>
        );
    }

    const sliderSettings = {
        dots: true,
        infinite: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        initialSlide: 0,
    };

    return (
        <div
            className={classnames(styles.testimonialsSliderWrapper, styles[data.style])}
            id={stripHash(data.anchorId)}
        >
            <div className={styles.rootContainer}>
                <Slider {...sliderSettings}>
                    {slides}
                </Slider>
            </div>
        </div>
    );
}